import {
	type DatePanelStepDirection,
	MONTHS_IN_YEAR,
} from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";

export const stepMonth = (
	year: number,
	monthIndex: number,
	direction: DatePanelStepDirection,
): { year: number; monthIndex: number } => {
	const steppedMonth = monthIndex + direction;

	if (steppedMonth < 0) {
		return { year: year - 1, monthIndex: MONTHS_IN_YEAR - 1 };
	}

	if (steppedMonth > MONTHS_IN_YEAR - 1) {
		return { year: year + 1, monthIndex: 0 };
	}

	return { year, monthIndex: steppedMonth };
};
